$(function($) {
	$('#themeForm').on('change', '#theme', function() {
		var search_params = new URLSearchParams(window.location.search);
		
		search_params.set('theme', this.value);
		window.location.search = search_params.toString();
	});
});